<div nz-row [nzGutter]="[0, 24]" class="references">
  <div nz-col [nzSpan]="24" *ngIf="references.length">
    <h3
      *ngIf="
        viewerAccountType === AccountType.ADMIN ||
        viewerAccountType === AccountType.ADMIN_TALENT_MANAGER ||
        viewerAccountType === AccountType.ADMIN_SALES_MANAGER
      "
    >
      {{ "references.references.title" | translate }}
    </h3>
    <nz-list nzItemLayout="vertical">
      <nz-list-item *ngFor="let reference of references" class="reference">
        <nz-list-item-meta>
          <nz-list-item-meta-title>
            {{ reference.referenceName }}
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <div class="reference__info">
          {{ reference.referenceCompany }}
          <nz-divider nzPlain nzType="vertical"></nz-divider>
          {{ reference.referencePosition }}
          <nz-divider nzPlain nzType="vertical"></nz-divider>
          <a *ngIf="trustedView" [href]="'mailto:' + reference.referenceEmail">
            {{ reference.referenceEmail }}
          </a>
          <span *ngIf="!trustedView">
            {{ reference.referenceEmail }}
          </span>
          <nz-divider nzPlain nzType="vertical"></nz-divider>
          <span class="reference__timestamp"> {{ reference.creationTimestamp }}</span>
        </div>
        <div class="reference__text">
          {{ reference.referenceText }}
        </div>
      </nz-list-item>
    </nz-list>
  </div>

  <div nz-col nzSpan="24" *ngIf="referencesRequest.length">
    <h3>{{ "references.my-references-requests.title" | translate }}</h3>
    <nz-list nzItemLayout="vertical">
      <nz-list-item *ngFor="let reference of referencesRequest" class="reference">
        <nz-list-item-meta>
          <nz-list-item-meta-title>
            {{ reference.referenceName }}
          </nz-list-item-meta-title>
        </nz-list-item-meta>
        <div class="reference__info">
          {{ reference.referenceCompany }}
          <nz-divider nzPlain nzType="vertical"></nz-divider>
          {{ reference.referencePosition }}
          <nz-divider nzPlain nzType="vertical"></nz-divider>
          <a [href]="'mailto:' + reference.referenceEmail">
            {{ reference.referenceEmail }}
          </a>
          <nz-divider nzPlain nzType="vertical"></nz-divider>
          <span class="reference__timestamp"> {{ reference.creationTimestamp }}</span>
        </div>
      </nz-list-item>
    </nz-list>
  </div>
</div>
